import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  floorLocations: [],
  isLoadingFloorLocations: false,
  isLoading: false,
  error: null,
};

export const getLocationsByBlockAndFloorCode: any = createAsyncThunk(
  "content/getLocationsByBlockAndFloorCode",
  async ({ PageNumber, PageSize }: any) => {
    const res = await axios.get(`/slpapp/DisplayLocation/GetAll`, {
      params: { PageNumber, PageSize },
    });

    const data = await res.data;

    return data;
  }
);

export const floorLocationSlice = createSlice({
  name: "floorLocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocationsByBlockAndFloorCode.pending, (state) => {
      state.isLoadingFloorLocations = true;
    });
    builder.addCase(
      getLocationsByBlockAndFloorCode.fulfilled,
      (state, action) => {
        state.isLoadingFloorLocations = false;
        state.floorLocations = action.payload;
      }
    );
    builder.addCase(
      getLocationsByBlockAndFloorCode.rejected,
      (state, action) => {
        state.isLoadingFloorLocations = false;
        state.error = action.error.message;
      }
    );
  },
});

export default floorLocationSlice.reducer;
